import { useState, useCallback, useMemo, useEffect } from "react";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import { useGlobalContext } from "../../../src/Context/GlobalContext";
import Profile from "../../Assets/Images/Profile.png";
import Cookies from "js-cookie";

export default function Dashboard() {
  const {
    clientDetail,
    loadingClient,
    fetchDetail,
    projectData,
    loadingProject,
    taskData,
    loadingTask,
  } = useGlobalContext();
  useEffect(() => {
    console.log("called", clientDetail, loadingClient);
  }, [clientDetail, loadingClient]);

  const [currentDate, setCurrentDate] = useState(new Date());
  const [selectedDate, setSelectedDate] = useState(new Date());
  const currentYear = currentDate.getFullYear();
  const currentMonth = currentDate.getMonth();
  const { baseUrl, openToast } = useGlobalContext();
  const [birthdays, setBirthdays] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [staffCount, setStaffCount] = useState(null);
  const [taskCount, setTaskCount] = useState(null);
  const [clientCount, setClientsCount] = useState(null);
  const [projectCount, setProjectCount] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [mayBirthdayPerson, setMayBirthdayPerson] = useState("");

  const isFestiveSeason = currentMonth === 11; // December

  const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const TableSkeleton = () => (
    <tr className="border-t">
      <td className="p-[10px] text-center">
        <Skeleton width={30} />
      </td>
      <td className="p-[10px] text-center">
        <Skeleton width={120} />
      </td>
      <td className="p-[10px] text-center">
        <Skeleton width={150} />
      </td>
      <td className="p-[10px] text-center">
        <Skeleton width={100} />
      </td>
    </tr>
  );

  const HeaderSkeleton = () => (
    <tr className="text-left">
      <th className="p-[8px] font-normal text-center text-md whitespace-nowrap">
        <Skeleton width={50} />
      </th>
      <th className="p-[8px] font-normal text-center text-md whitespace-nowrap">
        <Skeleton width={130} />
      </th>
      <th className="p-[8px] font-normal text-center text-md whitespace-nowrap">
        <Skeleton width={100} />
      </th>
      <th className="p-[8px] font-normal text-center text-md whitespace-nowrap">
        <Skeleton width={120} />
      </th>
    </tr>
  );

  const PaginationSkeleton = () => (
    <div className="flex gap-2 pt-0 pr-4 pb-0 pl-4 border rounded-md">
      <div className="pt-2 pb-[8px] px-2">
        <Skeleton width={60} />
      </div>
      <div className="pt-2 pb-[8px] px-3">
        <Skeleton width={20} />
      </div>
      <div className="pt-2 pb-[8px] px-2">
        <Skeleton width={40} />
      </div>
    </div>
  );
  const data = [
    { name: "A", uv: 0, pv: 2400, amt: 2400 },
    { name: "B", uv: 600, pv: 1398, amt: 2210 },
    { name: "C", uv: 1000, pv: 9800, amt: 2290 },
    { name: "D", uv: 1400, pv: 3908, amt: 2000 },
    { name: "E", uv: 1890, pv: 4800, amt: 2181 },
    { name: "F", uv: 2390, pv: 3800, amt: 2500 },
    { name: "G", uv: 3490, pv: 4300, amt: 2100 },
  ];

  async function totalStaff() {
    try {
      const response = await fetch(baseUrl + "staff/count", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
        },
      });
      if (response.status == 200) {
        const data = await response.json();
        const formattedCount = String(data?.count).padStart(2, "0");

        setStaffCount(formattedCount);
        return data;
      } else {
        const errorData = await response.json();
        openToast(
          `Error: ${errorData.message || "Failed to fetch staff count"}`,
          "Error"
        );
      }
    } catch (error) {
      openToast("An Error Occurred", "Error");
    }
  }

  async function totalTask() {
    try {
      const response = await fetch(baseUrl + `task/count`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
        },
      });

      if (response.status == 200) {
        const data = await response.json();
        const formattedCount = String(data?.taskCount).padStart(2, "0");
        setTaskCount(formattedCount);
      }
    } catch (error) {
      console.error("Error fetching total task count:", error.message);
      throw error;
    }
  }

  async function totalClients() {
    try {
      const response = await fetch(baseUrl + `client/count`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
        },
      });

      if (response.status == 200) {
        const data = await response.json();
        const formattedCount = String(data?.count).padStart(2, "0");
        setClientsCount(formattedCount);
      }
    } catch (error) {
      console.error("Error fetching client count:", error);
      throw error;
    }
  }

  async function totalProject() {
    try {
      const response = await fetch(baseUrl + `project/count`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
        },
      });

      if (response.status == 200) {
        const data = await response.json();
        const formattedCount = String(data?.count).padStart(2, "0");
        setProjectCount(formattedCount);
      }
    } catch (error) {
      console.error("Error fetching project count:", error);
      throw error;
    }
  }

  console.log(projectData);

  useEffect(() => {
    totalStaff();
    totalTask();
    totalClients();
    totalProject();
  }, []);

  async function fetchBirthday() {
    setLoading(true);
    try {
      const month = new Date(selectedDate).toLocaleString("en-US", {
        month: "short",
      });
      const response = await fetch(
        baseUrl +
          `staff/birthday?month=` +
          new Date(selectedDate).toLocaleString("en-US", { month: "short" }),
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
          },
        }
      );

      if (!response.ok) {
        const errorMessage = await response.text();
        console.error(
          "Fetch failed with status:",
          response.status,
          errorMessage
        );
        openToast("Unable to fetch birthdays. Please try again.", "error");
        setLoading(false);
        return;
      }

      const data = await response.json();
      if (data && data.data) {
        console.log(data.data);
        setBirthdays(data.data);
        // const mayBirthday = data.data.find((birthday) => {
        //   const date = new Date(birthday.date_of_birth)
        //   return date.getMonth() === 4 && date.getDate() === 13
        // })
        // setMayBirthdayPerson(mayBirthday ? mayBirthday.name : "")
      } else {
        console.warn("No birthday data found:", data);
        openToast("No birthdays available for the selected month.", "info");
      }
    } catch (error) {
      console.error("An error occurred while fetching birthdays:", error);
      setError(error.message);
      openToast("An error occurred while fetching birthdays.", "error");
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchBirthday();
  }, [selectedDate]);

  const metrics = [
    { label: "Total Task", value: taskCount, color: "text-purple-600" },
    { label: "Total Project", value: projectCount, color: "text-blue-600" },
    { label: "Total Clients", value: clientCount, color: "text-green-600" },
    { label: " Total Staff", value: staffCount, color: "text-orange-600" },
  ];

  const projects = [
    { id: 1, name: "Kweker", tasks: 39, completed: "86%" },
    { id: 2, name: "URBAN KHASA", tasks: 35, completed: "75%" },
  ];

  const tasks = [
    { id: 1, name: "Raj sir video", inProgress: 7, completed: 34 },
    { id: 2, name: "Facebook cover", inProgress: 5, completed: 31 },
  ];

  const goToPreviousMonth = useCallback(() => {
    setCurrentDate((prev) => {
      const prevMonth = new Date(prev);
      prevMonth.setMonth(prev.getMonth() - 1);
      setSelectedDate(prevMonth);
      return prevMonth;
    });
  }, []);

  const goToNextMonth = useCallback(() => {
    setCurrentDate((prev) => {
      const nextMonth = new Date(prev);
      nextMonth.setMonth(prev.getMonth() + 1);
      setSelectedDate(nextMonth);
      return nextMonth;
    });
  }, []);

  const goToToday = useCallback(() => {
    setCurrentDate(new Date());
    setSelectedDate(new Date());
  }, []);

  const handlePrevious = () => {
    if (currentPage <= 1) return;
    const prevPage = currentPage - 1;
    setCurrentPage(prevPage);
    fetchDetail(prevPage);
  };

  const handleNext = () => {
    if (currentPage > totalPage) return;
    const nextPage = currentPage + 1;
    setCurrentPage(nextPage);
    fetchDetail(nextPage);
  };

  const calendarDays = useMemo(() => {
    const daysInMonth = new Date(currentYear, currentMonth + 1, 0).getDate();
    const firstDayOfMonth = new Date(currentYear, currentMonth, 1).getDay();
    const prevMonthDays = new Date(currentYear, currentMonth, 0).getDate();
    const totalDays = [];

    const isBirthday = (date) => {
      const currentDateMonth = date.getMonth();
      const currentDateDay = date.getDate();
      return birthdays.find((birthday) => {
        const dobDateMonth = new Date(birthday.date_of_birth).getMonth();
        const dobDateDay = new Date(birthday.date_of_birth).getDate();
        return (
          (currentDateMonth === dobDateMonth &&
            currentDateDay === dobDateDay) ||
          (currentDateMonth === 4 && currentDateDay === 13)
        );
      });
    };

    for (let i = firstDayOfMonth - 1; i >= 0; i--) {
      const date = new Date(currentYear, currentMonth - 1, prevMonthDays - i);
      totalDays.push({
        date,
        day: prevMonthDays - i,
        currentMonth: false,
        isToday: isSameDay(date, new Date()),
        isSelected: selectedDate ? isSameDay(date, selectedDate) : false,
        isHighlighted: isBirthday(date),
      });
    }

    for (let i = 1; i <= daysInMonth; i++) {
      const date = new Date(currentYear, currentMonth, i);
      totalDays.push({
        date,
        day: i,
        currentMonth: true,
        isToday: isSameDay(date, new Date()),
        isSelected: selectedDate ? isSameDay(date, selectedDate) : false,
        isHighlighted: isBirthday(date),
      });
    }

    const remainingDays = 42 - totalDays.length;
    for (let i = 1; i <= remainingDays; i++) {
      const date = new Date(currentYear, currentMonth + 1, i);
      totalDays.push({
        date,
        day: i,
        currentMonth: false,
        isToday: isSameDay(date, new Date()),
        isSelected: selectedDate ? isSameDay(date, selectedDate) : false,
        isHighlighted: isBirthday(date),
      });
    }

    return totalDays;
  }, [currentYear, currentMonth, selectedDate, birthdays]);

  function isSameDay(date1, date2) {
    return (
      date1.getDate() === date2.getDate() &&
      date1.getMonth() === date2.getMonth() &&
      date1.getFullYear() === date2.getFullYear()
    );
  }

  const handleDateSelect = (date) => {
    setSelectedDate(date);
  };

  return (
    <div className="bg-white min-h-screen">
      <main className="p-6">
        <div className="flex flex-wrap justify-between items-center gap-2 mb-6">
          <h1 className="font-medium text-[22px] sm:text-2xl">Dashboard</h1>
        </div>

        <div className="gap-4 grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 mb-6">
          {metrics.map((metric, index) => (
            <div key={index} className="bg-white shadow-cs p-4 rounded-lg">
              <div className="font-medium text-[16px]">{metric.label}</div>
              <div className={`text-[17px] font-medium mt-1 ${metric.color}`}>
                {metric.value != null ? metric.value : <Skeleton />}
              </div>
            </div>
          ))}
        </div>

        <div className="gap-6 grid grid-cols-1 lg:grid-cols-3 mb-6">
          <div className="lg:col-span-2 bg-white shadow-cs p-4 rounded-lg">
            <div className="flex justify-between items-center mb-4">
              <div>
                <h2 className="font-medium text-md sm:text-lg">Expenditure</h2>
              </div>
              <div className="flex items-center gap-[20px]">
                <span className="text-[14px] sm:text-[14px]"> - Total</span>
                <span className="text-[14px] sm:text-[14px]"> - Online</span>
              </div>
            </div>
            <div className="chart-container">
              <div className="chart-scroll-area">
                <div className="chart-content">
                  <ResponsiveContainer width="100%" height={350}>
                    <AreaChart
                      data={data}
                      margin={{
                        top: 10,
                        right: 30,
                        left: 0,
                        bottom: 0,
                      }}
                    >
                      <CartesianGrid strokeDasharray="3 3" />
                      <XAxis dataKey="name" />
                      <YAxis />
                      <Tooltip />
                      <Area
                        type="monotone"
                        dataKey="uv"
                        stroke="#8884d8"
                        fill="#8884d8"
                      />
                    </AreaChart>
                  </ResponsiveContainer>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-white shadow-cs rounded-xl w-full overflow-hidden">
            <div className="p-4">
              <div className="flex items-center gap-[20px] mb-3">
                <img src={Profile || "/placeholder.svg"} alt="Profile" />
                <h4 className="font-medium">Birthday's Calendar</h4>
              </div>

              <div className="dashboard-calender">
                <div className="p-[10px]">
                  <div className="flex justify-end items-center mb-1">
                    <div className="flex items-center gap-2">
                      <button
                        onClick={goToPreviousMonth}
                        className="hover:bg-gray-100 p-2 rounded-full transition-colors"
                        aria-label="Previous month"
                      >
                        <FiChevronLeft className="w-5 h-5" />
                      </button>
                      <button
                        onClick={goToToday}
                        className="bg-gray-100 hover:bg-gray-200 px-3 py-1 rounded-full font-medium text-[13px] transition-colors"
                      >
                        {months[currentMonth].slice(0, 3)}
                      </button>
                      <button
                        onClick={goToNextMonth}
                        className="hover:bg-gray-100 p-2 rounded-full transition-colors"
                        aria-label="Next month"
                      >
                        <FiChevronRight className="w-5 h-5" />
                      </button>
                    </div>
                  </div>
                  <div className="gap-2 grid grid-cols-7">
                    {days.map((day) => (
                      <div
                        key={day}
                        className="py-2 font-medium text-center text-gray-500 text-sm"
                      >
                        {day}
                      </div>
                    ))}

                    {calendarDays.map((date, index) => (
                      <div key={index} className="relative group">
                        <button
                          onClick={() => handleDateSelect(date.date)}
                          className={`
                            relative w-full aspect-square flex flex-col items-center justify-center text-sm
                            transition-all duration-200 rounded-lg
                            ${
                              date.currentMonth
                                ? "hover:bg-gray-100 hover:text-black"
                                : "text-gray-400 hover:bg-gray-50"
                            }
                            ${
                              date.isHighlighted
                                ? "bg-red-500 text-white animate-pulse"
                                : ""
                            }
                          `}
                        >
                          <span className="relative z-10">{date.day}</span>
                        </button>
                        {(() => {
                          const adjustToLocalDate = (date) => {
                            const d = new Date(date);
                            d.setMinutes(
                              d.getMinutes() - d.getTimezoneOffset()
                            ); // Adjust to local timezone
                            return d.toISOString().split("T")[0]; // Extract YYYY-MM-DD
                          };
                          return (
                            birthdays?.some(
                              (staff) =>
                                new Date(
                                  adjustToLocalDate(date.date)
                                ).getMonth() ===
                                  new Date(staff?.date_of_birth).getMonth() &&
                                new Date(
                                  adjustToLocalDate(date.date)
                                ).getDate() ===
                                  new Date(staff?.date_of_birth).getDate()
                            ) && (
                              <div className="absolute bottom-[27px] left-[-30px] transform -translate-x-1/2 mb-2 px-2 py-1 bg-black text-white text-xs rounded opacity-0 group-hover:opacity-100 transition-opacity duration-200 whitespace-nowrap animate-bounce z-50">
                                {(() => {
                                  const result = birthdays?.filter(
                                    (staff) =>
                                      new Date(
                                        adjustToLocalDate(date.date)
                                      ).getMonth() ===
                                        new Date(
                                          staff?.date_of_birth
                                        ).getMonth() &&
                                      new Date(
                                        adjustToLocalDate(date.date)
                                      ).getDate() ===
                                        new Date(staff?.date_of_birth).getDate()
                                  );
                                  return result.length === 1
                                    ? result[0]?.name
                                    : result
                                        .map((item) => item.name)
                                        .join(", ")
                                        .replace(/,([^,]*)$/, " and$1");
                                })()}
                                's Birthday
                              </div>
                            )
                          );
                        })()}
                        {}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="gap-6 grid grid-cols-1 lg:grid-cols-2 mb-6">
          <div className="bg-white shadow-cs p-4 rounded-lg">
            <h2 className="mb-3 font-medium text-lg">Projects</h2>
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead className="bg-[#f7f6f6] shadow-cs">
                  <tr className="text-left">
                    <th className="p-[8px] font-normal text-center text-md whitespace-nowrap">
                      Sr No.
                    </th>
                    <th className="p-[8px] font-normal text-center text-md whitespace-nowrap">
                      Project Name
                    </th>
                    <th className="p-[8px] font-normal text-center text-md whitespace-nowrap">
                      Task
                    </th>
                    <th className="p-[8px] font-normal text-center text-md whitespace-nowrap">
                      Completed
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {loadingProject ? (
                    <tr>
                      <td colSpan="4" className="text-center py-4">
                        <Skeleton count={3} />
                      </td>
                    </tr>
                  ) : projectData && projectData.length > 0 ? (
                    projectData.map((project, index) => (
                      <tr key={project.id} className="border-t">
                        <td className="p-[10px] font-light text-center text-sm whitespace-nowrap">
                          {index + 1}
                        </td>
                        <td className="p-[10px] font-light text-center text-sm whitespace-nowrap">
                          {project?.project_name}
                        </td>

                        {project?.TaskDetail?.map((project) => (
                          <td className="p-[10px] font-light text-center text-sm whitespace-nowrap">
                            {project?.taskName || " "}
                          </td>
                        ))}

                        <td className="p-[10px] font-light text-center text-sm whitespace-nowrap">
                          {`${project?.projectStatus?.project_name}`}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="4" className="text-center py-4">
                        No projects found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>

          <div className="bg-white shadow-cs p-4 rounded-lg">
            <h2 className="mb-3 font-medium text-lg">Task Completion</h2>
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead className="bg-[#f7f6f6] shadow-cs">
                  {loadingTask ? (
                    <HeaderSkeleton />
                  ) : (
                    <tr className="text-left">
                      <th className="p-[8px] font-normal text-center text-md whitespace-nowrap">
                        Sr No.
                      </th>
                      <th className="p-[8px] font-normal text-center text-md whitespace-nowrap">
                        Task Name
                      </th>
                      <th className="p-[8px] font-normal text-center text-md whitespace-nowrap">
                        In Progress
                      </th>
                      <th className="p-[8px] font-normal text-center text-md whitespace-nowrap">
                        Completed
                      </th>
                    </tr>
                  )}
                </thead>

                <tbody>
                  {loadingTask ? (
                    <tr>
                      <td colSpan="4" className="text-center py-4">
                        <TableSkeleton />
                      </td>
                    </tr>
                  ) : taskData && taskData.length > 0 ? (
                    taskData.slice(0, 5).map((task, index) => (
                      <tr key={task.id} className="border-t">
                        <td className="p-[10px] font-light text-center text-sm whitespace-nowrap">
                          {index + 1}
                        </td>
                        <td className="p-[10px] font-light text-center text-sm whitespace-nowrap">
                          {task?.taskName}
                        </td>
                        <td className="p-[10px] font-light text-center text-sm whitespace-nowrap">
                          {task.taskStatus?.taskStatusName || "N/A"}
                        </td>
                        <td className="p-[10px] font-light text-center text-sm whitespace-nowrap">
                          {task.taskStatus?.taskStatusName || "N/A"}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="4" className="text-center py-4">
                        No tasks found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div className="bg-white shadow-cs p-4 rounded-lg">
          <div className="flex justify-between items-center mb-3 w-full">
            {loadingClient ? (
              <div className="font-medium text-lg">
                <Skeleton width={80} height={28} />
              </div>
            ) : (
              <h2 className="font-medium text-lg">Clients</h2>
            )}{" "}
            {loadingClient ? (
              <PaginationSkeleton />
            ) : (
              <div className="flex sm:flex-row flex-col justify-end items-center gap-2 sm:gap-0 pr-0 pb-[0] pl-0 w-[100%]">
                <div className="flex gap-2 pt-0 pr-4 pb-0 pl-4 border rounded-md pagination">
                  <button
                    onClick={handlePrevious}
                    disabled={currentPage === 1}
                    className={`pt-2 pb-[8px] text-[12px] ${
                      currentPage === 1 ? "opacity-40" : ""
                    }`}
                  >
                    Previous
                  </button>
                  <span className="flex items-center bg-[#27004a] pr-3 pl-3 text-[12px] text-white">
                    {currentPage}
                  </span>
                  <button
                    onClick={handleNext}
                    className={`pt-2 pb-[8px] text-[12px] ${
                      currentPage === totalPage ? "opacity-40" : ""
                    }`}
                  >
                    Next
                  </button>
                </div>
              </div>
            )}
          </div>
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="bg-[#f7f6f6] shadow-cs">
                {loadingClient ? (
                  <HeaderSkeleton />
                ) : (
                  <tr className="text-left">
                    <th className="p-[8px] font-normal text-center text-md whitespace-nowrap">
                      Sr. No
                    </th>
                    <th className="p-[8px] font-normal text-center text-md whitespace-nowrap">
                      Flowchanger Name
                    </th>
                    <th className="p-[8px] font-normal text-center text-md whitespace-nowrap">
                      Email
                    </th>
                    <th className="p-[8px] font-normal text-center text-md whitespace-nowrap">
                      Mobile Number
                    </th>
                  </tr>
                )}
              </thead>
              <tbody>
                {loadingClient ? (
                  <TableSkeleton />
                ) : clientDetail && clientDetail.length > 0 ? (
                  clientDetail.map((client, index) => (
                    <tr key={client.id} className="border-t">
                      <td className="p-[10px] text-center text-sm">
                        {index + 1}
                      </td>
                      <td className="p-[10px] font-light text-center text-sm whitespace-nowrap">
                        {client?.name ?? "N/A"}
                      </td>
                      <td className="p-[10px] font-light text-center text-sm whitespace-nowrap">
                        {client?.email ?? "N/A"}
                      </td>
                      <td className="p-[10px] font-light text-center text-sm whitespace-nowrap">
                        {client?.mobile ?? "N/A"}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan="11"
                      className="py-4 font-medium text-center text-gray-600 text-md"
                    >
                      No Client Found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </main>
    </div>
  );
}
